<app-attention-modal
  type="error"
  title="Reset Service Account"
  [messageTemplate]="message"
  [buttonsTemplate]="buttons"
></app-attention-modal>

<ng-template #message>
  <div>Are you sure you want to Reset this Service Account?</div>
</ng-template>

<ng-template #buttons>
  <button rktButton btnType="tertiary" title="Cancel" (click)="activeModal.close()" [disabled]="loading">Cancel</button>
  <button rktButton class="error-btn" title="Confirm" (click)="resetServiceAccount()" [disabled]="loading">Confirm</button>
</ng-template>
